// extracted by mini-css-extract-plugin
export default {"logo":"MedicalKnowledgeButton_logo__YnSRP","button":"MedicalKnowledgeButton_button__lY9vO","buttonfocus":"MedicalKnowledgeButton_buttonfocus__Krn++"};